import { getJwtTokenInStorage } from '../../service/CognitoAuthService';

export const getHeaders = (token) => ({
  Accept: 'application/json',
  'Content-type': 'application/json',
  Authorization: `Bearer ${token || getJwtTokenInStorage()}`,
});

export const getHeadersMultipart = (token) => ({
  'Content-Type': 'multipart/form-data',
  Authorization: `Bearer ${token || getJwtTokenInStorage()}`,
});
